<template>
<div class="flex flex-col">
  <div class="text-grey-darker text-2xl">
      {{this.screenTitleText}}    
  </div>
  
  <div class="my-2 text-grey text-bold text-md">
    {{this.screenSubtitle}}
  </div>

  <form class="flex w-full max-w-md">

    <div class="w-full md:w-2/3 mb-6 md:mb-0">
        <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-title">
          <span>{{this.inputLabel}}</span>
          <span class="text-red">*</span>
        </label>

        <input v-model="title" 
        class="appearance-none block w-full bg-grey-lightest text-grey-darker rounded py-3 px-4 mb-3 leading-tight border border-grey-lighter focus:outline-none focus:bg-white focus:border-grey" 
        id="grid-title" type="text" autofocus :placeholder="this.placeholderTitle">
  
        <!-- Change to notification, check: https://github.com/JoaquimLey/photobooks/issues/13 -->
        <div v-if="isCreateAlbumLoading" class="flex w-full max-w-sm justify-end text-grey text-bold text-lg">
          {{this.creatingMessage}} 
        </div>
      </div>

      <div class="w-full md:w-1/3 ml-2 mt-4">
        <button class="font-bold py-4 px-6 rounded-full focus:outline-none" 
          :class="{'shadow text-grey-dark hover:shadow-lg hover:text-grey-dark cursor-pointer' : isCreateEnabled, 
          'shadow-inner text-grey-light cursor-not-allowed': !isCreateEnabled}"
          type="button"
          @click="createAlbum">
        {{this.createButtonText}}
      </button>
    </div>
    
  </form>
</div>
</template>

<script>
import AlbumsRepository from "../repositories/AlbumsRepository";
export default {
  name: "NewAlbum",
  components: {},
  props: {},

  data() {
    return {
      // Data
      title: "",
      albumId: "",
      // Header
      screenTitleText: "New Album",
      screenSubtitle: "Uassap",
      // Form
      inputLabel: "Title",
      placeholderTitle: "Jessy and James Wedding",
      createButtonText: "Create",
      cancelButtonText: "Cancel",

      creatingMessage: "Creating...",
      isCreateAlbumLoading: false
    };
  },

  created: {},

  computed: {
    isCreateEnabled() {
      return this.title.length > 0;
    },

    isAlbumCreated() {
      return this.albumId.length > 0;
    },

    createdAlbumId() {
      return this.albumId;
    }
  },

  mounted() {},

  methods: {
    createAlbum() {
      if (!this.isCreateEnabled || this.isCreateAlbumLoading) {
        return;
      }

      this.isCreateAlbumLoading = true;
      AlbumsRepository.createAlbum(this.title)
        .then(result => {
          this.albumId = result.id;
          this.isCreateAlbumLoading = false;
          this.albumCreatedSuccess();
        })
        .catch(error => {
          this.isCreateAlbumLoading = false;
        });
    },

    albumCreatedSuccess() {
      this.$root.$emit('onAlbumSelected', this.albumId);
    },

    cancelCreateAlbum() {
      this.$root.$emit("onCreateAlbumCanceled");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/NewAlbum.vue